/**
 * Every domain's policies, one line per file in `policies/` (CAPABILITIES.md §3.4): adding a
 * domain is one line here, adding a capability none. The four files below declare the cart's ids
 * (P0 step 12) and hold no policy yet: C1 writes them, and until then the engine hides those ids.
 */
import { BILL_POLICIES } from "./policies/bill";
import { DISCOUNT_POLICIES } from "./policies/discount";
import { ORDER_POLICIES } from "./policies/order";
import { PAYMENT_POLICIES } from "./policies/payment";
import type { PolicySet } from "./types";

export const policyIndex: readonly PolicySet[] = [ORDER_POLICIES, BILL_POLICIES, DISCOUNT_POLICIES, PAYMENT_POLICIES];
